import toast, { Toaster, ToastBar } from 'react-hot-toast';

// Custom toast functions with your design system
export const showToast = {
  success: (message: string) => {
    toast.success(message, {
      duration: 3000,
      position: 'top-center',
      style: {
        background: '#047857',
        color: '#fff',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#047857',
      },
    });
  },

  error: (message: string) => {
    toast.error(message, {
      duration: 3000,
      position: 'top-center',
      style: {
        background: '#DC2626',
        color: '#fff',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#DC2626',
      },
    });
  },

  info: (message: string) => {
    toast(message, {
      duration: 3000,
      position: 'top-center',
      icon: 'ℹ️',
      style: {
        background: '#681628',
        color: '#fff',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
    });
  },

  loading: (message: string) => {
    return toast.loading(message, {
      position: 'top-center',
      style: {
        background: '#fff',
        color: '#374151',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        border: '1px solid #E5E7EB',
      },
    });
  },

  promise: <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
    }
  ) => {
    return toast.promise(
      promise,
      {
        loading: messages.loading,
        success: messages.success,
        error: messages.error,
      },
      {
        position: 'top-center',
        style: {
          padding: '16px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
        },
        success: {
          style: {
            background: '#047857',
            color: '#fff',
          },
          iconTheme: {
            primary: '#fff',
            secondary: '#047857',
          },
        },
        error: {
          style: {
            background: '#DC2626',
            color: '#fff',
          },
          iconTheme: {
            primary: '#fff',
            secondary: '#DC2626',
          },
        },
      }
    );
  },
};

// Custom Toaster component with your design
export const CustomToaster = () => (
  <Toaster
    position="top-center"
    reverseOrder={false}
    gutter={8}
    toastOptions={{
      duration: 3000,
      style: {
        background: '#fff',
        color: '#374151',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      },
    }}
  >
    {(t) => (
      <ToastBar toast={t}>
        {({ icon, message }) => (
          <div className="flex items-center gap-3 w-full">
            {icon}
            <div className="flex-1">{message}</div>
            {t.type !== 'loading' && (
              <button
                onClick={() => toast.dismiss(t.id)}
                className="flex-shrink-0 rounded-full p-1 hover:bg-black hover:bg-opacity-10 transition-colors"
                aria-label="Close notification"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            )}
          </div>
        )}
      </ToastBar>
    )}
  </Toaster>
);

export { toast };
